export enum LINK_TYPE {
  GOOGLE = 'GOOGLE',
  ZALO = 'ZALO',
  APPLE = 'APPLE',
  FACEBOOK = 'FACEBOOK'
}
